import { render, staticRenderFns } from "./textManagement.vue?vue&type=template&id=32955821&scoped=true"
import script from "./textManagement.vue?vue&type=script&lang=js"
export * from "./textManagement.vue?vue&type=script&lang=js"
import style0 from "./textManagement.vue?vue&type=style&index=0&id=32955821&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32955821",
  null
  
)

export default component.exports